module.exports = __webpack_public_path__ + "media/images/iconLeft__inactive-564849e7bcfc397dbe610e9ea668449a.png";